import {ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild} from "@angular/core";
import {NbDialogRef, NbDialogService} from "@nebular/theme";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {UmbrellaValidators} from "../../validation/umbrella-validators";
import {Actions, ofType} from "@ngrx/effects";
import {ReviewerActions} from "../../../store/actions/reviewer.actions";

@Component({
    selector: 'review-decline-dialog',
    templateUrl: './review-decline-dialog.template.html',
    styleUrls: ['./review-decline-dialog.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ReviewDeclineDialogComponent implements OnInit {

	@Output() onOrderDeclined: EventEmitter<string> = new EventEmitter<string>();

	@ViewChild('dialog', {static: false}) dialog: TemplateRef<any>;
	private dialogRef: NbDialogRef<any>;

	declineOrderForm: FormGroup;

	reason: string = '';
	declineButtonClicked: boolean = false;

	constructor(private dialogService: NbDialogService, private actions$: Actions) {
	}

	ngOnInit(): void {
		this.declineOrderForm = new FormGroup({
			decliningReason: new FormControl(null, [UmbrellaValidators.maxLength(5000), UmbrellaValidators.nonEmpty, Validators.required])
		});

		this.actions$.pipe(ofType(ReviewerActions.DECLINE_APPLICATION_REVIEW_FAILURE))
			.subscribe(() => {
				this.closeDeclineDialog();
			});
	}

	getDeclineFormErrors(): string[] | null {
		return Object.keys(this.declineOrderForm.get('decliningReason').errors).map(key => {
			if (key === 'required' || key === 'empty') {
				return "Required";
			} else if (key === 'maxlength') {
				return "Provided reason is too long";
			}
			return "Error";
		});
	}

	showDeclineDialog() {
		this.dialogRef = this.dialogService.open(this.dialog, {closeOnEsc: false, closeOnBackdropClick: false});
	}

	closeDeclineDialog() {
		this.reason = '';
		this.declineButtonClicked = false;
		if (this.dialogRef) {
			this.dialogRef.close();
		}
	}

	buttonClicked(): boolean {
		return this.declineButtonClicked;
	}

	emptyReason(): boolean {
		return this.reason === '';
	}

	isDeclineReasonControlPristine(): boolean {
		return this.declineOrderForm.controls['decliningReason'].pristine;
	}

	isFormPristine(): boolean {
		return this.declineOrderForm.pristine;
	}

	emitDeclinedClicked(reason: string) {
		setTimeout(() => {
			if (this.dialogRef) {
				this.dialogRef.close()
			}
			this.onOrderDeclined.emit(reason);
			this.declineButtonClicked = true;
		}, 500);
	}
}
